<div class="container hide-overflow-print" #container>
    <kendo-chart #chart [ngStyle]="getStyle()" [seriesColors]="seriesColors" (seriesClick)="onSeriesClick($event)">
        <kendo-chart-category-axis>
            <kendo-chart-category-axis-item *ngFor="let item of categoryAxisItems;trackBy:trackByFn"
                [baseUnit]="item.baseUnit" [visible]="item.visible" [max]="item.max" [min]="item.min"
                [labels]="{ format: chartLabelFormat, rotation: 'auto' }" [majorGridLines]="{ visible: false }">
            </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-value-axis>
            <kendo-chart-value-axis-item>
                <kendo-chart-value-axis-item-labels [content]="labelContent">
                </kendo-chart-value-axis-item-labels>
            </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>
        <kendo-chart-legend position="top" orientation="horizontal"></kendo-chart-legend>
        <kendo-chart-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-point="point">
                <span>{{ point.series.name }} - {{ category | date:chartToolTipFormat }} -
                    {{ labelContent(point) }}</span>
            </ng-template>
        </kendo-chart-tooltip>
        <kendo-chart-series>
            <kendo-chart-series-item *ngFor="let item of series;trackBy:trackByFn" type="line" [data]="item.items"
                field="value" [name]="item.value" categoryField="category"
                [markers]="{ visible: item.items.length===1 }">
            </kendo-chart-series-item>
        </kendo-chart-series>
    </kendo-chart>
</div>